// extracted by mini-css-extract-plugin
export default {"iconNoColor":"IconNoStrokeColor_iconNoColor__Pru0J"};